import React from 'react'

import {
  AlignItems,
  Box,
  Display,
  FlexDirection,
  Image,
  JustifyContent,
} from '@gousto-internal/citrus-react'

type TwoColumnLayoutProps = {
  image: {
    src: string
    alt: string
  }
  children: React.ReactNode
}

export function TwoColumnLayout({ image, children }: TwoColumnLayoutProps) {
  return (
    <Box
      display={Display.Flex}
      alignItems={AlignItems.Center}
      justifyContent={JustifyContent.SpaceEvenly}
      flexDirection={[FlexDirection.Column, null, null, FlexDirection.Row]}
      paddingH={[8, 20]}
      paddingV={16}
      paddingBottom={6}
      gap={[4, 8]}
    >
      <Box width={[null, null, null, '600px']} paddingBottom={[3, 4]}>
        {children}
      </Box>
      <Box width={[null, null, null, '600px']} paddingBottom={[3, 4]}>
        <Image style={{ borderRadius: '8px' }} fit="cover" alt={image.alt} src={image.src} />
      </Box>
    </Box>
  )
}
